import { DependencyList, EffectCallback, useLayoutEffect } from 'react';
import { useDeepCompareMemoize } from './utils';

export function useDeepCompareLayoutEffect(callback: EffectCallback, dependencies: DependencyList) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useLayoutEffect(callback, dependencies.map(useDeepCompareMemoize));
}
